export default __webpack_public_path__ + "static/media/X_wdt_c_cap_1.abc3689f.mp3";